module.exports = function(done, value){
  return {value: value, done: !!done};
};


/** WEBPACK FOOTER **
 ** ./~/react-native-winjs/~/core-js/library/modules/$.iter-step.js
 **/